import { useContext } from 'react'

import useInspectionEntriesByStatus from '../../hooks/useInspectionEntriesByStatus/useInspectionEntriesByStatus'
import { SingleInspectionContext } from '../../providers/SingleInspectionProvider/SingleInspectionProvider'
import { DviSingleInspectionContent } from './DviSingleInspectionContent'

export const DviSingleInspectionNotCached = () => {
  const {
    inspectionWithRelated: inspection,
    repairOrder,
    vehicle,
    isLoading,
    inspectionExpanded,
    customer,
    cannedJobsExpanded
  } = useContext(SingleInspectionContext)
  const { entriesByStatus } = useInspectionEntriesByStatus(
    inspectionExpanded,
    cannedJobsExpanded
  )

  return (
    <DviSingleInspectionContent
      {...{
        inspection,
        repairOrder,
        vehicle,
        isLoading,
        customer,
        entriesByStatus
      }}
    />
  )
}
